/* eslint-disable no-unused-vars */
import React from 'react'
import './check-input.scss'
// library
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

interface CheckInputProps {
	readonly label?: React.ReactNode
	readonly setActive?: (active: boolean) => void
	readonly onClick?: () => void
	readonly active?: boolean
	readonly error?: string
	readonly classes?: string
	readonly rounded?: boolean
	readonly id?: string
	readonly labelClassName?: string
}

const CheckInput: React.FC<CheckInputProps> = ({
	label,
	setActive,
	onClick,
	active = false,
	error,
	classes,
	rounded = false,
	id,
	labelClassName = ''
}) => {
	return (
		<div className={`a-check-input gtmSaludContinuaClicHomeRecordatorio ${classes || ''}`}>
			<button
				type='button'
				className={
					'a-check-value-indicator ' +
					(active ? 'active ' : '') +
					(error ? 'error' : '') +
					(rounded ? 'rounded' : '') +
					' gtmSaludContinuaClicHomeRecordatorio'
				}
				id={id}
				data-testid={id}
				onClick={() => {
					setActive && setActive(!active)
					onClick && onClick()
				}}
			>
				{rounded ? (
					<span className='a-check-value-indicator__rounded' />
				) : (
					<FontAwesomeIcon icon={faCheck} />
				)}
			</button>
			{label && <div className={`a-check-label-container ${labelClassName}`}>{label}</div>}
			{error && <span className='a-check-input-error'>{error}</span>}
		</div>
	)
}

export default CheckInput
